import React from "react";
import { Topic } from "../../../Models/Topic";
import TopicSummaryGridItemContainer from "./Items/TopicSummaryGridItemContainer";
import { TopicQuickMetrics } from "../../../Models/TopicQuickMetrics";
import { LoadingState, ErrorDisplay } from "../../../../Common";

type Props = {
  topics: Topic[];
  topicMetrics: Record<string, TopicQuickMetrics>;
  topicMetricsLoadingState: LoadingState;
};

export default class TopicSummaryGrid extends React.Component<Props> {
  render() {
    return (
      <>
        {this.props.topics.map(el => {
          const thisItemMetrics = this.props.topicMetrics[el.code];

          if (this.props.topicMetricsLoadingState.isLoaded && !thisItemMetrics) {
            return (
              <ErrorDisplay
                errorResult="Could not load metrics"
                errorDescription={`Metrics were not provided for topic with code ${el.code}`}
              />
            );
          }

          return (
            <TopicSummaryGridItemContainer
              topic={el}
              key={el.code}
              metrics={thisItemMetrics}
              loadingState={this.props.topicMetricsLoadingState}
            />
          );
        })}
      </>
    );
  }
}
